import { LeafErrorMessage } from "../../../../../../common/leaf/LeafErrorMessage/LeafErrorMessage";
import BirthdayInfo from "../../../../../../components/ABOProfile/InfoComponents/BirthdayInfo/BirthdayInfo";
import LeafDateJoinedInfo, {
  BUSINESS_ENTRY_KEY,
  BUSINESS_NATURE_EFFECTIVE_DATE_KEY,
} from "../../../../../../components/ABOProfile/InfoComponents/DateJoinedInfo/DateJoinedInfo";
import RecentOrderDateInfo from "../../../../../../components/ABOProfile/InfoComponents/RecentOrderDateInfo/RecentOrderDateInfo";
import RecentSponsorDateInfo from "../../../../../../components/ABOProfile/InfoComponents/RecentSponsorDateInfo/RecentSponsorDateInfo";
import RenewalDateInfo from "../../../../../../components/ABOProfile/InfoComponents/RenewalDateInfo/RenewalDateInfo";
import ProfileLoader from "../../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import { useGetABOProfileQuery } from "../../../../../../services/AboProfile/AboProfileAPI";
import { useAppSelector } from "../../../../../../store";
import "./DatesTab.scss";

const DatesTab = () => {
  // Get Login ABO
  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const [aff = "", abo = ""] = affAbo.split("-");
  const isFromEdLos = useAppSelector((state) => state.profile.isFromEdLos);
  const profileInfo = useAppSelector((state) => state.boot?.configuration?.profile?.aboInfo);

  const { showBirthday, showEntryDate, showRecentOrderDate, showRenewalDate, showRecentSponsorDate } =
    profileInfo || {};

  const {
    isFetching: isFetchingProfile,
    isError: isErrorProfile,
    data: profileData,
  } = useGetABOProfileQuery({ aff, abo, ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}) });

  // Display loading state
  if (isFetchingProfile === true) {
    return <ProfileLoader row={5} card={true} isFetching={isFetchingProfile} />;
  }

  // Display error state
  if (isErrorProfile === true) {
    return <LeafErrorMessage show={isErrorProfile} />;
  }

  // Profile Data
  const {
    isoBirthdate = "",
    entryDate = "",
    renewalDate = "",
    recentSponsorDate = "",
    currentBusinessNatureEffectiveDate = "",
  } = profileData?.aboInfo || {};

  const { aboRecentOrderDate = "" } = profileData?.orderInfo || {};

  const showBusinessNatureEffectiveDate =
    currentBusinessNatureEffectiveDate !== "--" && currentBusinessNatureEffectiveDate !== entryDate;

  return (
    <div className="key-dates-tab__container">
      <div className="key-dates-tab__content">
        <BirthdayInfo date={isoBirthdate} show={showBirthday} />
        <RenewalDateInfo date={renewalDate} show={showRenewalDate} />
        <LeafDateJoinedInfo
          date={currentBusinessNatureEffectiveDate}
          show={showBusinessNatureEffectiveDate}
          title={BUSINESS_NATURE_EFFECTIVE_DATE_KEY}
        />
        <LeafDateJoinedInfo date={entryDate} show={showEntryDate} title={BUSINESS_ENTRY_KEY} />
        <RecentSponsorDateInfo date={recentSponsorDate} show={showRecentSponsorDate} />
        <RecentOrderDateInfo date={aboRecentOrderDate} show={showRecentOrderDate} />
      </div>
    </div>
  );
};

export default DatesTab;
